// extracted by mini-css-extract-plugin
export default {"mobile":"Header_mobile__XyWA1","desktop":"Header_desktop__d4QgZ"};